import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getEvidenceList as getEvidenceListApi,
	getEvidence as getEvidenceApi,
	addNewEvidence as addNewEvidenceApi,
	updateEvidence as updateEvidenceApi,
	deleteEvidence as deleteEvidenceApi,
	reviewEvidence as reviewEvidenceApi
} from '../../helpers/normative/backend_helper';

export const getEvidenceList = createAsyncThunk('evidence/getEvidenceList', async (params) => {
	try {
		const response = getEvidenceListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getEvidence = createAsyncThunk('evidence/getEvidence', async evidence_id => {
	try {
		const response = getEvidenceApi(evidence_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewEvidence = createAsyncThunk('evidence/addNewEvidence', async evidence => {
	try {
		const response = addNewEvidenceApi(evidence);
		toast.success('Evidencia agregada exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar Evidencia.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateEvidence = createAsyncThunk('evidence/updateEvidence', async (evidence) => {
		try {
			const response = updateEvidenceApi(evidence);
			toast.success('Tipo de Evidencia actualizada exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar Tipo de Evidencia.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteEvidence = createAsyncThunk('evidence/deleteEvidence', async evidence => {
	try {
		const response = await deleteEvidenceApi(evidence);
		toast.success('Evidencia eliminada exitosamente.', { autoClose: 3000 });
		return { evidence, ...response };
	} catch (error) {
		toast.error('Error al eliminar Evidencia.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const reviewEvidence = createAsyncThunk('evidence/reviewEvidence', async evidence => {
	// toast.info('Estamos guardando la revisión', { autoClose: 3000 })
	try {
		const response = reviewEvidenceApi(evidence);
		if(evidence.revised){
			toast.success(`Se ha marcado como revisada la evidencia.`, { autoClose: 3000 });
		}else{
			toast.success(`Se ha ${evidence.approved ? 'aprobado' : 'rechazado'} la evidencia.`, { autoClose: 3000 });
		}
		return response;
	} catch (error) {
		toast.error('Error al revisar evidencia.', { autoClose: 3000 });
		throw new Error(error);
	}
});